import app from '../../../public-api';
import {MarkupService} from './markup-service';

app.plugins.register({
  name: 'us:annotations:markup',

  extends: 'viewport',

  dependency: 'us:annotations:service',

  canStart () {
    // TODO: Check user rights.
    return true;
  },

  factory (uScope, viewport, annotationsService) {
    const markupService = new MarkupService(uScope, viewport, annotationsService);
    markupService.init();
    return markupService;
  }
});



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/image-analysis/markup/markup-region-loader.js